import { MenuItem } from "@mui/material";
import { Field } from "formik";
import { Select } from "formik-mui";

import { useTranslation } from "react-i18next";
import { useIndicators } from "hooks/indicatorHooks";

import { LayerProperties } from "types";

interface Props {
  className?: string;
  config: string;
  layerProperties: LayerProperties[];
}

export function LayerSearchLayerSelect(props: Props) {
  const { config, className, layerProperties } = props;
  const { t } = useTranslation();
  const { data: indicators } = useIndicators(
    config,
    {
      limit: 10,
      offset: 0,
      searchable: true,
    },
    layerProperties
  );

  return (
    <Field
      component={Select}
      id="layer"
      name="layer"
      variant="standard"
      formControl={{ fullWidth: true, className, variant: "standard" }}
      label={t("label.layerToSearchWithin")}
    >
      {indicators &&
        indicators.totalCount &&
        indicators.data.map((layers) => (
          <MenuItem key={layers.id} value={layers.id}>
            {layers.title}
          </MenuItem>
        ))}
    </Field>
  );
}
